import React from 'react';
import { Tag, seg } from '../../tags/Tag';
import type { CoreTagColor } from '../../tags/Tag';
import { PrimaryButton, PrimaryButtonProps } from '../../button/PrimaryButton';

export interface StateCardProps {
  // Card styling
  variant?: 'ghost' | 'filled' | 'bordered';
  width?: number | string;
  className?: string;
  style?: React.CSSProperties;
  
  // Content
  icon?: React.ComponentType<{ size?: number }>;
  iconVariant?: CoreTagColor;
  title: string;
  subtitle?: string;
  
  // Action button
  buttonText?: string;
  buttonProps?: Omit<PrimaryButtonProps, 'title'>;
  onButtonClick?: () => void;
}

export const StateCard: React.FC<StateCardProps> = ({
  variant = 'ghost',
  width = 480,
  className = '',
  style = {},
  icon: Icon,
  iconVariant = 'neutral',
  title,
  subtitle,
  buttonText,
  buttonProps,
  onButtonClick
}) => {

  // Card width style using CSS custom property
  const cardStyle: React.CSSProperties = {
    ['--card-max-width' as any]: typeof width === 'number' ? `${width}px` : width,
    ...style
  };
  
  return (
    <div 
      className={`core-state-card core-state-card--${variant} ${className}`.trim()}
      style={cardStyle}
    >
      {Icon && (
        <Tag
          segments={[seg.icon(Icon)]}
          color={iconVariant || 'neutral'}
          shape="rect"
          border="none"
          className="core-state-card__icon"
        />
      )}
      
      <h3 className="core-state-card__title">
        {title}
      </h3>
      
      {subtitle && (
        <p className="core-state-card__subtitle">
          {subtitle}
        </p>
      )}
      
      {buttonText && (
        <div className="core-state-card__button">
          <PrimaryButton
            variant="default"
            size="small"
            title={buttonText}
            onClick={onButtonClick}
            fullWidth={false}
            align="center"
            {...buttonProps}
          />
        </div>
      )}
    </div>
  );
};

export default StateCard;
